// extracted by mini-css-extract-plugin
export var container = "personCard-module--container--b62a8";
export var heading = "personCard-module--heading--84d46";
export var imgContainer = "personCard-module--imgContainer--c22c0";
export var imgLoaded = "personCard-module--imgLoaded--185cc";
export var imgLoading = "personCard-module--imgLoading--90bba";
export var info = "personCard-module--info--c7bf3";